import { Button } from 'components';
import { PlusIcon } from 'lib/svgs/Icons';
import { useTranslations } from 'next-intl';
import Link from 'next/link';

const GoogleConnect = () => {
  const t = useTranslations();

  const scopes: string[] = [
    'https://www.googleapis.com/auth/adwords',
    'https://www.googleapis.com/auth/adsense',
    'https://www.googleapis.com/auth/dfp' // Google ads manager
  ];
  // https://developers.google.com/identity/protocols/oauth2/web-server#httprest_1
  return (
    <>
      <Link
        className="mt-6 w-full"
        href={
          `https://accounts.google.com/o/oauth2/auth?client_id=${process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID}` +
          `&redirect_uri=${process.env.NEXT_PUBLIC_REDIRECT_HOST}/external/google/callback` +
          `&scope=${scopes.join(' ')}` +
          `&response_type=code` +
          `&access_type=offline`
        }
      >
        <Button
          colorIcon="white"
          color="secondary"
          size="small"
          className="w-full"
          startAdornment={<PlusIcon className="scale-125" />}
          label={t('integrations.connect')}
        />
      </Link>
    </>
  );
};

export default GoogleConnect;
